<mat-card class="u-background-color-neutral-0">
  <mat-card-header>
    <mat-card-title>
      <img class="c-global-mat-icon" src="{{hostName}}/assets/images/icon-app-glide-coloured.svg" />
      {{"organization.create.section_4.glide_section.title" | translate }}
      {{"organization.create.section_4.settings" | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-accordion multi="true">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"organization.create.section_4.glide_section.fulfilment_types.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        {{"organization.create.section_4.glide_section.content_message" | translate }}
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"organization.create.section_4.glide_section.product_management.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div
          *ngIf="isCompanyLevel || showProductRecommendation || showCatalogueScreen || showRealTimeStockAvailability || showDisablePromotion; else productManagementPlaceholder"
          [formGroup]="productManagementForm"
          class="catalogue-screen"
        >
          <ng-container *ngIf="isCompanyLevel || showCatalogueScreen">
            <div class="catalogue-screen__row" fxLayout="row" fxLayoutAlign="start center">
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.product_management.catalogue_screen.title"
                | translate }}
              </span>
              <mat-slide-toggle
                id="matSlideToggleCatalogueScreen"
                formControlName="catalogueScreenEnabled"
                (change)="toggleCatalogueScreen()"
              >
              </mat-slide-toggle>
            </div>
            <div
              *ngIf="productManagementForm.get('catalogueScreenEnabled')?.value"
              class="catalogue-screen__row catalogue-screen__row--field"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.product_management.catalogue_screen.dropdown_label"
                | translate }}
              </span>
              <mat-form-field class="catalogue-screen__field" id="matFrmFieldCatalogueConfig">
                <mat-select
                  id="matSelectCatalogueConfig"
                  formControlName="catalogueConfig"
                  [placeholder]="('organization.create.section_4.glide_section.product_management.catalogue_screen.dropdown_placeholder' | translate) + '*'"
                >
                  <mat-option *ngFor="let config of catalogueConfigOptions" [value]="config.id">
                    {{ config.name }}
                  </mat-option>
                </mat-select>
                <mat-error id="matErrorCatalogueConfigRequired" class="error-message">
                  {{"organization.create.section_4.glide_section.product_management.catalogue_screen.dropdown_required"
                  | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <ng-container *ngIf="showProductRecommendation">
            <div class="catalogue-screen__row" fxLayout="row" fxLayoutAlign="start center">
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.product_management.product_recommendation.title"
                | translate }}
              </span>
              <mat-slide-toggle
                id="matSlideToggleProductRecommendation"
                formControlName="productRecommendationEnabled"
                (change)="toggleProductRecommendation()"
              >
              </mat-slide-toggle>
            </div>
            <div
              *ngIf="productManagementForm.get('productRecommendationEnabled')?.value"
              class="catalogue-screen__row catalogue-screen__row--field"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.product_management.product_recommendation.dropdown_label"
                | translate }}
              </span>
              <mat-form-field class="catalogue-screen__field" id="matFrmFieldProductRecommendation">
                <mat-select
                  id="matSelectProductRecommendation"
                  formControlName="productRecommendationConfig"
                  [placeholder]="('organization.create.section_4.glide_section.product_management.product_recommendation.dropdown_placeholder' | translate) + '*'"
                >
                  <mat-option
                    *ngFor="let config of productRecommendationOptions"
                    [value]="config.id"
                  >
                    {{ config.name }}
                  </mat-option>
                </mat-select>
                <mat-error id="matErrorProductRecommendationRequired" class="error-message">
                  {{"organization.create.section_4.glide_section.product_management.product_recommendation.dropdown_required"
                  | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div
              *ngIf="productManagementForm.get('productRecommendationEnabled')?.value"
              class="catalogue-screen__row catalogue-screen__row--field"
              fxLayout="row"
              fxLayoutAlign="end center"
            >
              <mat-form-field
                class="catalogue-screen__field"
                id="matFrmFieldProductRecommendationMessage"
              >
                <textarea
                  matInput
                  id="matInputProductRecommendationMessage"
                  rows="3"
                  maxlength="100"
                  formControlName="productRecommendationMessage"
                  [placeholder]="'organization.create.section_4.glide_section.product_management.product_recommendation.custom_message_placeholder' | translate"
                ></textarea>
                <mat-error
                  *ngIf="productManagementForm.get('productRecommendationMessage')?.hasError('required')"
                  class="error-message"
                >
                  {{"organization.create.section_4.glide_section.product_management.product_recommendation.custom_message_required"
                  | translate }}
                </mat-error>
                <mat-error
                  *ngIf="productManagementForm.get('productRecommendationMessage')?.hasError('maxlength')"
                  class="error-message"
                >
                  {{"organization.create.section_4.glide_section.product_management.product_recommendation.custom_message_max_length"
                  | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>

          <!-- Real time stock availability (GE-4543) -->
          <ng-container *ngIf="showRealTimeStockAvailability">
            <div class="catalogue-screen__row" fxLayout="row" fxLayoutAlign="start center">
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.title"
                | translate }}
              </span>
              <mat-slide-toggle
                id="matSlideToggleRealTimeStockAvailability"
                formControlName="realTimeStockAvailabilityEnabled"
                (change)="toggleRealTimeStockAvailability()"
              >
              </mat-slide-toggle>
            </div>
            <div
              *ngIf="productManagementForm.get('realTimeStockAvailabilityEnabled')?.value"
              class="catalogue-screen__row catalogue-screen__row--wide"
            >
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.store_list_label"
                | translate }}
              </span>
              <app-store-hierarchy-selector
                [hierarchy]="storeHierarchy"
                [selectedStoreIds]="realTimeStockStoreIdsControl?.value ?? []"
                [lockedStoreId]="forcedStoreId"
                (selectionChange)="onStoreSelectionChange($event)"
              ></app-store-hierarchy-selector>
            </div>
            <!-- No mat-form-field here, so mat-error is unavailable; needs its own element. -->
            <div
              *ngIf="productManagementForm.get('realTimeStockAvailabilityEnabled')?.value && realTimeStockStoreIdsControl?.touched && realTimeStockStoreIdsControl?.hasError('required')"
              id="divRealTimeStockStoreRequired"
              class="catalogue-screen__row error-message catalogue-screen__store-error"
            >
              {{"organization.create.section_4.glide_section.product_management.real_time_stock_availability.store_required"
              | translate }}
            </div>
          </ng-container>

          <!-- Disable Promotion (GE-5258). After the Real time stock Stores table. -->
          <div
            *ngIf="showDisablePromotion"
            class="catalogue-screen__row"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <span class="catalogue-screen__label">
              {{"organization.create.section_4.glide_section.product_management.disable_promotion.title"
              | translate }}
            </span>
            <mat-slide-toggle
              id="matSlideToggleGlideDisablePromotion"
              formControlName="disablePromotionEnabled"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <ng-template #productManagementPlaceholder>
          {{"organization.create.section_4.glide_section.content_message" | translate }}
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"organization.create.section_4.glide_section.payment_settings.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Controls here are bound with [formControl] rather than a second [formGroup] +
             formControlName: they live in productManagementForm, which is already bound in
             the Product Management panel above, and binding one FormGroup to two
             FormGroupDirectives is not a supported pattern. -->
        <div
          *ngIf="showSplitPayments || showVoidAfterPartPayment; else paymentSettingsPlaceholder"
          class="catalogue-screen"
        >
          <!-- Split Payments (GE-5004). Hidden at organisation level. -->
          <div
            *ngIf="showSplitPayments"
            class="catalogue-screen__row"
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <span class="catalogue-screen__label">
              {{"organization.create.section_4.glide_section.payment_settings.split_payments.title"
              | translate }}
            </span>
            <mat-slide-toggle id="matSlideToggleSplitPayments" [formControl]="splitPaymentsControl">
            </mat-slide-toggle>
          </div>

          <!-- Void after part payment (GE-4848). Shown at organisation level as well. -->
          <ng-container *ngIf="showVoidAfterPartPayment">
            <div class="catalogue-screen__row" fxLayout="row" fxLayoutAlign="start center">
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.payment_settings.void_transaction_after_part_payment"
                | translate }}
              </span>
              <mat-slide-toggle
                id="matSlideToggleVoidAfterPartPayment"
                [formControl]="voidTransactionControl"
                (change)="toggleVoidAfterPartPayment()"
              >
              </mat-slide-toggle>
            </div>
            <div
              *ngIf="voidTransactionControl?.value"
              class="catalogue-screen__row catalogue-screen__row--field"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <span class="catalogue-screen__label">
                {{"organization.create.section_4.glide_section.payment_settings.payment_failure_retry_limit"
                | translate }}
              </span>
              <mat-form-field
                class="catalogue-screen__field"
                id="matFrmFieldGlidePaymentFailureRetryLimit"
              >
                <input
                  matInput
                  id="txtGlidePaymentFailureRetryLimit"
                  numbersOnly="true"
                  maxlength="9"
                  required
                  [formControl]="paymentFailureRetryLimitControl"
                />
                <mat-error
                  id="matErrorGlidePaymentFailureRetryLimit"
                  class="error-message"
                  *ngIf="paymentFailureRetryLimitControl?.hasError('required') || paymentFailureRetryLimitControl?.hasError('pattern')"
                >
                  {{"organization.create.section_4.glide_section.payment_settings.payment_failure_retry_limit_validation"
                  | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </ng-container>
        </div>
        <ng-template #paymentSettingsPlaceholder>
          {{"organization.create.section_4.glide_section.content_message" | translate }}
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"organization.create.section_4.glide_section.module_ui_configurations.title" |
            translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        {{"organization.create.section_4.glide_section.content_message" | translate }}
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"organization.create.section_4.glide_section.customer_hub.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        {{"organization.create.section_4.glide_section.content_message" | translate }}
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{"organization.create.section_4.glide_section.receipt.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        {{"organization.create.section_4.glide_section.content_message" | translate }}
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
